import { useTranslation } from 'react-i18next';
import { Link, Redirect } from 'wouter';
import SettingsRow from '~/components/ui/SettingsRow';
import { useBranding } from '~/lib/branding';
import useCompactLayout from '~/lib/useCompactLayout';
import ProfileOverview from '../profile/ProfileOverview';

function Home() {
  const compact = useCompactLayout();
  const branding = useBranding();
  const { t } = useTranslation();
  if (!compact) return <Redirect to="/profile" />;

  return (
    <div>
      <ProfileOverview overview />
      <h1 className="mt-6 mb-2.5 font-sans text-[13px] tracking-normal font-semibold text-section-title">
        {t('account.title')}
      </h1>
      <nav
        aria-label={t('account.title')}
        className="flex flex-col gap-2.5 compact:[&>a]:min-h-20 compact:[&>a]:p-3.5"
      >
        <SettingsRow
          as={Link}
          href="/profile"
          icon="person"
          label={t('layout.menu.profile')}
          value={t('account.profileDescription')}
          standalone
        />
        {branding === 'hero' && (
          <SettingsRow
            as={Link}
            href="/earning"
            icon="paid"
            label={t('layout.menu.earning')}
            value={t('account.earningDescription')}
            standalone
          />
        )}
        <SettingsRow
          as={Link}
          href="/support"
          icon="support"
          label={t('layout.menu.support')}
          value={t('account.supportDescription')}
          standalone
        />
        <SettingsRow
          as={Link}
          href="/data-management"
          icon="database"
          label={t('layout.menu.dataManagement')}
          value={t('pageDescription.dataManagement')}
          standalone
        />
      </nav>
    </div>
  );
}

export default Home;
